import { defaultSampleAccountData } from '../../../../backend/config/classifiers/badge-template-classifier/defaultSampleAccountData';
import { sampleImageGenerationBarcodeData } from '../../../../backend/features/badges/shared/sampleImageGenerationBarcodeData';
import Handlebars from 'handlebars';
import React from 'react';
import { BadgePreviewContext } from '../contexts/BadgePreviewContext';
/**
 * Hook that compiles Badge Template
 *
 * * Use this to compile template for future use with {@link BadgePreview}
 * * To just render Badge Template - use {@link BadgeTemplatePreview} instead
 */
export function useBadgeTemplatePreview({ badgeTemplate, badgeTemplateClassifier, formSettings, account }) {
    const { onGetDataForBadgeTemplateImageGeneration } = React.useContext(BadgePreviewContext);
    const [renderedBadgeTemplate, setRenderedBadgeTemplate] = React.useState('');
    const sampleAccount = account !== null && account !== void 0 ? account : defaultSampleAccountData;
    React.useEffect(() => {
        if (!badgeTemplate)
            return;
        const compiledBadgeTemplate = Handlebars.compile(badgeTemplate);
        void onGetDataForBadgeTemplateImageGeneration(badgeTemplateClassifier, formSettings, sampleAccount, sampleImageGenerationBarcodeData).then((templateData) => {
            try {
                const badgeTemplateWithData = compiledBadgeTemplate(templateData);
                setRenderedBadgeTemplate(badgeTemplateWithData);
            }
            catch (error) {
                // eslint-disable-next-line
                console.error('Error compiling SVG:', error);
            }
        });
    }, [badgeTemplate, formSettings, badgeTemplateClassifier, onGetDataForBadgeTemplateImageGeneration, sampleAccount]);
    return renderedBadgeTemplate;
}
